import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { WHY, FALLBACK_FAQS } from "@/lib/content";
import { useList, Faq } from "@/lib/api";
import { MaskLines, Reveal } from "@/components/site/Motion";
import { FaqList } from "@/components/site/FaqList";

export function WhyUs() {
  return (
    <section data-testid="why-section" className="bg-cream-sand py-24 sm:py-32">
      <div className="wrap grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <p className="eyebrow">Why Wellness Radiance</p>
          <h2 className="mt-5 text-5xl leading-[0.98] text-forest sm:text-6xl">
            <MaskLines lines={["Warm. Specific.", <em key="h" className="text-pine">Honest.</em>]} />
          </h2>
          <Reveal>
            <div className="relative mt-10 aspect-[5/4] overflow-hidden rounded-[30px]" style={{ clipPath: "polygon(0 0, 100% 6%, 100% 100%, 0 94%)" }}>
              <img src="/images/cooking.jpg" alt="Woman cooking a fresh home meal in her kitchen" loading="lazy" className="h-full w-full object-cover" />
            </div>
          </Reveal>
        </div>
        <div className="grid gap-px overflow-hidden rounded-[30px] bg-forest/10 sm:grid-cols-2 lg:col-span-7">
          {WHY.map((w, i) => (
            <div key={w.title} data-testid={`why-item-${i}`} className="group bg-cream-sand p-8 transition-colors duration-500 hover:bg-cream sm:p-10">
              <Reveal delay={i * 0.08}>
                <span className="font-display text-5xl italic text-gold">0{i + 1}</span>
                <h3 className="mt-6 font-display text-3xl leading-tight text-forest">{w.title}</h3>
                <p className="mt-3 text-base leading-relaxed text-charcoal-soft">{w.text}</p>
              </Reveal>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function FaqTeaser() {
  const { items } = useList<Faq>("/faqs?featured=true", FALLBACK_FAQS);
  return (
    <section data-testid="faq-teaser-section" className="bg-cream py-24 sm:py-32">
      <div className="wrap grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <p className="eyebrow">Questions</p>
          <h2 className="mt-5 text-5xl leading-[0.98] text-forest sm:text-6xl">
            <MaskLines lines={["Asked often,", <em key="a" className="text-pine">answered plainly.</em>]} />
          </h2>
          <Link to="/faq" data-testid="faq-teaser-all-link" className="btn-ghost mt-8">All questions <ArrowRight className="h-4 w-4" /></Link>
        </div>
        <Reveal className="lg:col-span-8"><FaqList items={items} testPrefix="faq-teaser" /></Reveal>
      </div>
    </section>
  );
}
